<div class="modal-header">

   <div class="modal-title">

      <h2 class="text-uppercase d-inline-block">
         @if (shareholder?.id) {
            <span>
               <span class="shareholder-name">{{shareholder?.firstName}} {{shareholder?.lastName}}</span>
               @if (shareholder?.repurchaseOptionAsOf) {
                  <span class="ps-3 text-error font-weight-bold">* REPURCHASE OPTION *</span>
               }
            </span>
         } @else {
            ADD NEW SHAREHOLDER
         }
      </h2>

      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
   </div>

  <div class="modal-nav-menu clearfix" [hidden]="!(shareholder?.id)">
    <span (click)="goToSection(ShareholderEditSection_.basicInfo)" class="link">Basic Info</span><span class="separator">|</span>
    <span (click)="goToSection(ShareholderEditSection_.planInfo)" class="link">Stock Plan Info</span><span class="separator">|</span>
    <span (click)="goToSection(ShareholderEditSection_.dividendInfo)" class="link">Dividend Info</span>
  </div>

</div>

<div class="modal-body pt-0">

  <app-shareholder-edit [shareholder]="shareholder"
                    [canEdit]="canEdit"
                    (shareholderUpdated)="shareholderUpdated($event)">
  </app-shareholder-edit>

</div>
